enum EScheduleRepetitionType {
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
}

enum EDayOfWeek {
  Monday = '1',
  Tuesday = '2',
  Wednesday = '3',
  Thursday = '4',
  Friday = '5',
  Saturday = '6',
  Sunday = '0',
}

enum ECrontabSpecialChars {
  EmptyValue = '',
  AnyValue = '*',
  ValueListSeparator = ',',
  RangeOfValues = '-',
  StepValues = '/',
}

type TPublicationSchedule = {
  id: string;
  enabled: boolean;
  datetime_start: string;
  repetition_times: number | null;
  repetition_type: EScheduleRepetitionType | null;
  repetition_day_of_week: string | null;
  timezone: string;
  datetime_end: string | null;
};

export { ECrontabSpecialChars, EDayOfWeek, EScheduleRepetitionType };
export type { TPublicationSchedule };
